import React, { cloneElement } from 'react'
import PropTypes from 'prop-types'
import { flatten } from 'libraries/lodash'
import cx from 'classnames'
import { pushSearchHistory } from 'services/SessionService'
import Icon from 'components/shared/Icon'
import Button from '@material-ui/core/Button'
import TealToolTip from 'components/TealToolTip'

export const ContentSelector = ({ children, selected, label, listCxNames = '' }) => (
  <div className='flex justify-center w-100 pv4'>
    {label && <div><span>{label}</span></div>}
    <FlavourBottleButtons {...{ listCxNames, children, selected }} />
  </div>
)

const FlavourBottleButtons = ({ listCxNames, children, selected }) => (
  <ul className={cx(listCxNames)}>
    {flatten(children)
      .filter(x => x)
      .map(child => {
        const { props: { type } } = child
        return (cloneElement(child, { key: type, active: type === selected ? true : undefined }))
      })}
  </ul>
)

export const Option = ({ qa, link, icon, phrase, type, tooltip, active }) => {
  const flavour = qa && `qa-${type.substr(0, 4)}`

  return (
    <li>
      <TealToolTip placement='top' title={tooltip}>
        <Button
          href={link}
          onClick={() => typeof (type) === 'string' && pushSearchHistory(phrase, flavour || type)}
          className={cx(type, { selected: active })}
          data-event-category='Content'
          data-event-action='Select'
          data-event-label={type}
        >
          <span className={cx({ active })}>
            <Icon name={icon} className='w6 vm' />
          </span>
        </Button>
      </TealToolTip>
    </li>
  )
}

const OptionType = PropTypes.objectOf(Option)

ContentSelector.propTypes = {
  children: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.bool,
      OptionType,
      PropTypes.arrayOf(OptionType)
    ])
  )
}
